import { motion, useAnimation } from 'framer-motion';
import { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

const ParticleContainer = styled.div`

`;

const ParticlesWrapper = styled.div`

`;

const Particle = styled(motion.div)`

`;

const IconWrapper = styled.div`
 
`;

const MUSIC_NOTES = [''];

const IconExplosion = ({ 
  children, 
  color = '#8B4513', 
  particleCount = 12,
  minSpeed = 1,
  maxSpeed = 5
}) => {
  const [isExploding, setIsExploding] = useState(false);
  const containerRef = useRef(null);

  const createParticles = () => {
    return Array.from({ length: particleCount }).map((_, i) => ({
      id: i,
      note: MUSIC_NOTES[Math.floor(Math.random() * MUSIC_NOTES.length)],
      angle: (i * (360 / particleCount)) * (Math.PI / 180),
      speed: Math.random() * (maxSpeed - minSpeed) + minSpeed,
      initialScale: Math.random() * 0.8 + 1.2,
      rotateStart: Math.random() * 360,
      rotateEnd: Math.random() * 360 + 360
    }));
  };

  const handleMouseEnter = () => {
    if (!isExploding) {
      setIsExploding(true);
    }
  };

  const handleMouseLeave = () => {
    setIsExploding(false);
  };

  return (
    <ParticleContainer 
      ref={containerRef} 
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <IconWrapper>
        {children}
      </IconWrapper>
      
      {isExploding && (
        <ParticlesWrapper>
          {createParticles().map((particle) => (
            <Particle
              key={particle.id}
              color={color}
              initial={{
                x: 0,
                y: 0,
                scale: 0,
                opacity: 0,
                rotate: particle.rotateStart
              }}
              animate={{
                x: [0, Math.cos(particle.angle) * 30],
                y: [0, Math.sin(particle.angle) * 30],
                scale: [0, particle.initialScale, particle.initialScale],
                opacity: [0, 1, 0.8],
                rotate: particle.rotateEnd
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              {particle.note}
            </Particle>
          ))}
        </ParticlesWrapper>
      )}
    </ParticleContainer>
  );
};

export default IconExplosion;
